"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productByProductType = exports.simulitasService = void 0;

var _constants = require("../../constants");

var _Simulation = require("../../entities/Simulation");

var _fetcher = require("./fetcher");

var _SimulitasException = require("./SimulitasException");

const handleError = axiosError => {
  if (!axiosError.response || axiosError.response.status === 500) throw new _SimulitasException.SimulitasException(axiosError.message, _SimulitasException.SimulitasExceptionTypes.SERVER_ERROR);
  if (!axiosError.response.data || !axiosError.response.data.code) throw new _SimulitasException.SimulitasException(axiosError.message, _SimulitasException.SimulitasExceptionTypes.UNKNOWN_ERROR);
  const {
    message,
    code
  } = axiosError.response.data;
  throw new _SimulitasException.SimulitasException(message, code);
};

const productByProductType = productType => ({
  [_constants.ProductTypes.AUTO]: 'AUTOREFIN',
  [_constants.ProductTypes.HOME]: 'HOMEREFIN'
})[productType];

exports.productByProductType = productByProductType;

const convertToSimulationList = items => {
  return items.map(item => new _Simulation.Simulation({
    interestRateMonthly: item.interestRate.monthly,
    installmentsQuantity: item.installments.quantity,
    installmentsAmount: item.installments.amount
  }));
};

const simulitasService = (fetcher = _fetcher.simulitasFetcher) => {
  const getSimulations = async ({
    productType,
    intendedCredit,
    interestRateType = _constants.InterestRateTypes.MINIMUM
  } = {}) => {
    try {
      const response = await fetcher.get('/simulations', {
        params: {
          product: productByProductType(productType),
          intendedCredit,
          interestRateType
        }
      });
      return convertToSimulationList(response.data.items);
    } catch (error) {
      return handleError(error);
    }
  };

  return {
    getSimulations
  };
};

exports.simulitasService = simulitasService;